import { axiosPrivate } from 'shared/api';
import { IFolder } from 'features/inventory/documents-G4/types';
import { BaseService } from 'shared/services/BaseService';

class FMFolderService extends BaseService<IFolder> {
  constructor() {
    super('folders');
  }

  getFoldersByNameStartingWith = async (name: string) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/by-folder-name/`, {
      params: { name: name }
    });
    return res.data;
  };
}

export const fmFolderService = new FMFolderService();
